export default function RecruitHero() {
  return (
    <section className="relative min-h-[580px] md:min-h-[680px] flex items-center justify-center overflow-hidden">
      <img
        src="https://public.readdy.ai/ai/img_res/b527fcbae6f1cd3366f0cc9532b8adec.jpg"
        alt="直播主招募"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/55 to-black/75" />
      <div className="relative z-10 text-center px-4 w-full max-w-4xl mx-auto">
        <div className="flex justify-center mb-5">
          <img
            src="https://public.readdy.ai/ai/img_res/2de05ae8-ab7f-40ca-afb5-96f93dc606a2.png"
            alt="Rappy me Logo"
            className="h-20 w-20 object-contain drop-shadow-lg"
          />
        </div>
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-red-600/80 text-white text-xs font-semibold mb-6 tracking-widest uppercase">
          <i className="ri-live-line text-yellow-300" />
          Now Recruiting
        </div>
        <h1 className="text-4xl md:text-6xl font-black text-white mb-4 leading-tight" style={{ fontFamily: "'Noto Serif TC', serif" }}>
          應徵直播主
          <span className="block text-red-400 mt-1">開啟你的發光舞台</span>
        </h1>
        <p className="text-white/80 text-base md:text-lg max-w-2xl mx-auto leading-relaxed mb-3">
          別讓朝九晚五限制了你的才華！<br />
          在 17LIVE / 浪LIVE，你就是自己的老闆。
        </p>
        <p className="text-yellow-300 text-sm font-semibold mb-8">
          ✨ 零經驗也能上手 · 專業培訓 · 流量扶持 · 努力看得見
        </p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <a
            href="#recruit-form"
            className="inline-flex items-center justify-center gap-2 px-8 py-3.5 rounded-full bg-red-600 text-white font-semibold text-sm hover:bg-red-700 transition-all cursor-pointer whitespace-nowrap"
          >
            <i className="ri-user-add-line" />
            立即報名應徵
          </a>
          <a
            href="#recruit-benefits"
            className="inline-flex items-center justify-center gap-2 px-8 py-3.5 rounded-full border-2 border-white text-white font-semibold text-sm hover:bg-white hover:text-gray-900 transition-all cursor-pointer whitespace-nowrap"
          >
            <i className="ri-star-line" />
            了解更多福利
          </a>
        </div>
      </div>
    </section>
  );
}
